"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function DollarPlain24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.5 1H13.5V4.0487C15.4414 4.2426 16.9935 5.00655 18.1414 6.17971L16.9462 7.5942C15.751 6.29565 14.0777 5.73913 12.3327 5.73913C10.4442 5.73913 9.05777 6.73623 9.05777 8.1971C9.05777 9.71705 10.8608 10.192 12.8911 10.7268C15.5069 11.4159 18.5 12.2043 18.5 15.4551C18.5 17.5222 17.1396 19.6693 13.5 19.9654V23H11.5V19.941C9.30645 19.7045 7.62968 18.7773 6.5 17.542L7.69522 16.058C8.72311 17.2174 10.4442 18.2841 12.6912 18.2841C15.5359 18.2841 16.4442 16.8 16.4442 15.5942C16.4442 13.7616 14.4507 13.241 12.2956 12.6783C9.76053 12.0163 7.00199 11.296 7.00199 8.31304C7.00199 6.0401 8.86216 4.3932 11.5 4.06144V1Z", fill: "#383F49" }));
}
function DollarPlain24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(DollarPlain24Svg, Object.assign({}, svgProps)));
}
exports.default = DollarPlain24;
//# sourceMappingURL=DollarPlain24.js.map